import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { CommunitySubscription, PermissionLevel } from '@models';
import {
  AuthenticationService,
  BillingService,
  UserBeanService,
  i18nService,
} from '@services';

export const subscriptionsResolver: ResolveFn<
  Nullable<CommunitySubscription[]>
> = async () => {
  const billingService = inject(BillingService);
  const authenticationService = inject(AuthenticationService);
  const userBeanService = inject(UserBeanService);
  const i18n = inject(i18nService);

  const settings = await authenticationService.getSystemSettings();
  const userBean = await userBeanService.getUserBean();

  i18n.getLocale(settings);

  if (userBean.communityPermission === PermissionLevel.MODIFY_AND_DELETE) {
    return billingService.getSubscriptions({ onlyActive: true });
  }

  return null;
};
